import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryAccessFetchFailedAction = {
	type: 'BENEFICIARY_ACCESS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryAccessFetchFailedAction => ({
	type: 'BENEFICIARY_ACCESS_FETCH_FAILED',
	payload,
});
